import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import {
  PaymentFormValues,
  UploadPaymentState,
} from 'redux/types/Allocation.types';

export const uploadPaymentFileInitialState: UploadPaymentState = {
  loading: false,
  error: null,
  success: false,
};

const uploadPaymentFileSlice = createSlice({
  name: 'uploadPaymentFile',
  initialState: uploadPaymentFileInitialState,
  reducers: {
    uploadPaymentFileReq(
      state,
      action: PayloadAction<{ formData: PaymentFormValues; vendorId: string }>
    ) {
      state.loading = true;
      state.error = null;
      state.success = false;
    },
    uploadPaymentFileSuccess(state) {
      state.loading = false;
      state.success = true;
    },
    uploadPaymentFileFailure(state) {
      state.loading = false;
      state.error = 'error';
    },
    resetUploadPaymentState: () => uploadPaymentFileInitialState,
  },
});

export const {
  uploadPaymentFileReq,
  uploadPaymentFileSuccess,
  uploadPaymentFileFailure,
  resetUploadPaymentState,
} = uploadPaymentFileSlice.actions;

export default uploadPaymentFileSlice.reducer;
